module.exports = __webpack_public_path__ + "static/media/arrow_up.11489225.svg";